import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@material-ui/core';
import ProfileCircle from './profileCircle';
import {
  changeCategoryColor,
  ringPercentage,
} from '../../../../helpers/LoyaltyHelper';
import { useProfileRingStyles } from './styles';

const ProfileRing = ({ ...props }) => {
  const { totalPoints, firstName, lastName, categoryType } = props;
  const classes = useProfileRingStyles({
    color: changeCategoryColor(categoryType),
  });
  return (
    <Box
      position="relative"
      display="inline-flex"
      className={classes.circleContainer}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size={90}
        className={classes.bottom}
        thickness={1}
      />
      <CircularProgress
        variant="determinate"
        value={ringPercentage(totalPoints)}
        className={classes.circle}
        size={90}
        thickness={2}
      />
      <Box
        position="absolute"
        display="flex"
        alignContent="center"
        justifyContent="center"
        alignItems="center"
        top={0}
        left={0}
        right={0}
        bottom={0}
      >
        <ProfileCircle size="78px" firstName={firstName} lastName={lastName} />
      </Box>
    </Box>
  );
};

ProfileRing.propTypes = {
  totalPoints: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  categoryType: PropTypes.string,
};

export default ProfileRing;
